import { client } from '@/api';
import * as types from '../../mutationTypes';

async function get({ commit }) {
  let parentData = null;
  const clientData = await client.getClient();

  if (clientData.data.parentId) {
    parentData = client.getClientParent();
  }

  const childrenData = client.getClientChildren();

  const result = await Promise.all([
    ...(clientData.data.parentId ? [parentData] : []),
    childrenData
  ]);

  commit(types.UPDATE_CLIENT, {
    ...clientData.data,
    parent: result.length === 2 ? result[0].data : null,
    children: result[result.length - 1].data
  });
}

async function getAccessDetails({ commit }) {
  try {
    const clientAccessDetails = await client.getClientAccessDetails();

    if (clientAccessDetails.status === 200 && clientAccessDetails.data) {
      commit(types.SET_ACCESS_DETAILS, clientAccessDetails.data);
    }
  } catch (error) {
    console.log('getClientAccessDetails Error: ', error.message);
  }
}

export default {
  get,
  getAccessDetails
};
